import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SignageGuard implements CanActivate {
  constructor(private route: Router, private authenticationService: AuthenticationService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const position = this.authenticationService.USER_ROLES?.position?.toLowerCase() ?? '';
    const allowedRole = 'transportation dashboard add-on';
    const currentUrl = state.url;
    // Allow only users with the specific role on the transportation dashboard routes
    if (currentUrl.startsWith('/signage') && position === allowedRole) {
      return true;
    }
    // Otherwise redirect to home and block activation
    this.route.navigate(['/home']);
    return false;
  }
}
